import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormValueSection from "../../components/values/FormValueSection";
import { useGetValueSection } from "../../hooks/values/useGetValueSection";
import { useUpdateValueSection } from "../../hooks/values/useUpdateValueSection";

const ValueSection = () => {
    const { valueSection, isLoading: isFetching } = useGetValueSection();
    const { mutate, isPending: isUpdating } = useUpdateValueSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormValueSection
                currentData={valueSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default ValueSection;
